import { computed } from 'vue'
// types
import type { ComputedRef } from 'vue'
import type { BlockCardImpactProps } from '@ts-blocks/block-card-impact/interfaces'

interface BlockCardImpactHookOptions {
  block: () => BlockCardImpactProps
}

interface BlockCardImpactHookReturn {
  refImageAlt: ComputedRef<string>
}

export const useBlockCardImpact = ({ block }: BlockCardImpactHookOptions): BlockCardImpactHookReturn => {
  const refImageAlt = computed<string>(() => (
    block().image?.alternativeText ?? block().title ?? ''
  ))

  return {
    refImageAlt,
  }
}
